"use client"

import { useEffect, useState } from "react"
import { Group, Text, Badge } from "@forestsync/ui"
import { isMarketOpen, nextSessionOpen, nextSessionClose } from "@forestsync/lib/formatting"

function formatCountdown(ms: number): string {
  if (ms <= 0) return "00:00:00"
  const total = Math.floor(ms / 1000)
  const h = Math.floor(total / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  return [h, m, s].map((n) => String(n).padStart(2, "0")).join(":")
}

function formatOsloTime(d: Date): string {
  return d.toLocaleTimeString("en-GB", {
    timeZone: "Europe/Oslo",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  })
}

export function SessionStatus() {
  const [now, setNow] = useState(() => new Date())

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000)
    return () => clearInterval(id)
  }, [])

  const open = isMarketOpen(now)
  const target = open ? nextSessionClose(now) : nextSessionOpen(now)
  const countdown = formatCountdown(target.getTime() - now.getTime())
  const label = open ? `Closes in ${countdown}` : `Opens in ${countdown}`

  return (
    <Group gap={6} wrap="nowrap">
      <Text size="xs" c="dimmed" ff="monospace">{formatOsloTime(now)} CET</Text>
      <Badge size="xs" color={open ? "green" : "gray"} variant="filled">
        {open ? "OPEN" : "CLOSED"}
      </Badge>
      <Text size="xs" c="dimmed">{label}</Text>
    </Group>
  )
}
